import Member from 'components/company/revamp/parts/member';
import { useFetchMemberGroup } from './useFetch';

function MemberCompany() {
  useFetchMemberGroup();
  return (
    <Member />
  );
}

export default MemberCompany;
